<template>
  <div class="filters-container" :class="{ 'on-map': isMap, open: activeAside && isMap }">
    <span class="icon-container">
      <i v-if="transportMode.icon === 'walking'" class="material-icons">directions_walk</i>
      <i v-else :class="[`icon-${transportMode.icon}`]" />
    </span>

    <div class="filter-legend">
      {{ $t('activeFilters', filterLabels.length) }}
      <span class="collaborator-count"> <AnimatedValue :value="collaborators.length" /> {{ $t('filters.collaborators', collaborators.length) }} </span>
    </div>

    <div class="filter-box">
      <TransitionGroup name="list" tag="span">
        <div v-for="item in filterLabels" :key="item.item + item.key" class="filter-block" @click="() => updateParams(item)">
          {{ item.label }} <i class="icon-cross" />
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AnimatedValue from '@/components/AnimatedValue';
import TransportMode from '@/pure/TransportMode';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  components: {
    AnimatedValue,
  },

  props: {
    isMap: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      study: 'study',
      filters: 'filters',
      collaborators: 'collaborators',
      globalFilters: 'globalFilters',
      isDesktop: 'isDesktop',
      activeAside: 'activeAside',
    }),

    transportMode() {
      let currentMatchingTime = this.globalFilters.currentMatchingTime;
      if (currentMatchingTime.includes('public')) {
        currentMatchingTime = 'public';
      } else if (currentMatchingTime.includes('private')) {
        currentMatchingTime = 'private';
      }
      return TransportMode.find(item => item.key === currentMatchingTime);
    },

    filterLabels() {
      let labels = [];
      for (const key in this.filters) {
        this.filters[key].forEach(item => {
          labels.push({
            key,
            item: item,
            label: key === 'transportType' ? this.$t(`transportMode.${item}`) : item,
          });
        });
      }
      return labels;
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    updateParams(filter) {
      const newFilter = [];
      const actualFilter = this.filters[filter.key];
      for (const key in actualFilter) {
        if (actualFilter[key] !== filter.item) {
          newFilter.push(actualFilter[key]);
        }
      }
      this.$store.dispatch('updateFilters', {
        key: filter.key,
        value: newFilter,
      });
      if (!this.isDesktop || this.$route.name === 'Controller') {
        if (this.study && this.study.collaborators_total > 2000) {
          const id = this.study.id || this.$route.params.studyId;
          this.$store.dispatch('uploadRawData', { id: id, content: this.$store.getters.screen() }).then(result => {
            this.$socket.invoke('action', { action: 'tvBlob', parameters: result });
          });
        } else {
          this.$socket.invoke('action', { action: 'tvData', parameters: this.$store.getters.screen() });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.75em;
  padding-right: 0.15em;
  padding-left: 0.15em;
  border-right: 1px solid #d8d8d8;
  i {
    font-size: 1.5em;
  }
}
.collaborator-count {
  display: block;
  font-size: 14px;
  color: #9d9c9c;
}
.filters-container {
  display: flex;
  margin: 0 -24px 14px;
  padding: 8px 24px 0;
  min-height: 42px;
  position: sticky;
  background-color: #f4f4f4;
  top: -4px;
  transition: left 0.8s 0.1s;
  z-index: 2;

  &.on-map {
    background: none;
    right: 190px;

    &.open {
      left: 320px;
    }
  }
}
.filter-legend {
  color: #77797f;
  font-weight: 600;
  .thumb & {
    display: none;
  }
}
.filter-box {
  flex: 1;
  margin-left: 10px;
  display: inline-block;
}
.filter-block {
  height: 32px;
  display: inline-block;
  font-size: 14px;
  color: #262631;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  line-height: 30px;
  padding-left: 1em;
  padding-right: 0.3em;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.5s;
  user-select: none;
  pointer-events: all;
  &.list-leave-active {
    position: absolute;
  }
  &:hover {
    background-color: #d8d8d8;
  }
  i {
    color: #bc141a;
  }
}
</style>
